export default __webpack_public_path__ + "static/media/macbook-iPhone_mockup.png.webp";